import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';

// TikTok icon component since lucide doesn't have it
const TikTokIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer
      data-testid="footer"
      className="border-t border-border/50 bg-card/30"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 align-middle">
  <img
    src="/images/dd3.png"
    alt="Damian Depasquale"
    className="h-8 w-auto object-contain"
  />
  <span className="text-muted-foreground text-sm font-light leading-none">
    Creative Studio
  </span>
            </Link>
            <p className="text-muted-foreground mt-4 max-w-sm text-sm leading-relaxed">
              A creative studio focused on building modern visuals for brands,
              businesses, and digital platforms.
            </p>
            
            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://instagram.com/damiandepasquale.studio"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/damiandepasquale.studio"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://tiktok.com/@ddesign.creativestudio"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-tiktok"
                className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all"
                aria-label="TikTok"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Working Hours */}
          <div>
            <h4 className="font-['Sora'] font-semibold text-foreground mb-4">
              Working Hours
            </h4>
            <ul className="space-y-2">
              <li className="text-sm">
                <span className="text-muted-foreground">Monday – Friday:</span>
                <span className="text-foreground ml-2">9:00 AM – 6:00 PM</span>
              </li>
              <li className="text-sm">
                <span className="text-muted-foreground">Saturday:</span>
                <span className="text-foreground ml-2">10:00 AM – 2:00 PM</span>
              </li>
              <li className="text-sm">
                <span className="text-muted-foreground">Sunday:</span>
                <span className="text-foreground ml-2">Closed</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Sora'] font-semibold text-foreground mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:depasqualedamian@gmail.com"
                  data-testid="footer-email"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  depasqualedamian@gmail.com
                </a>
              </li>
              <li>
                <Link
                  to="/start-project"
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-sm text-primary hover:text-primary/80 transition-colors font-medium"
                >
                  Start a Project
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border/50 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {currentYear} Damian Depasquale Creative Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/terms"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/faq"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="text-xs text-muted-foreground hover:text-primary transition-colors"
            >
              FAQ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
